import React from 'react';
import { StepWrapper } from '@teetsh/app/src/containers/Demarrage/components/StepWrapper';
import 'twin.macro';
import { useDemarrage } from '@teetsh/app/src/containers/Demarrage/queries/useDemarrage';
import { useFinalizeDemarrage } from '@teetsh/app/src/containers/Demarrage/queries/useFinalizeDemarrage';
import { useUpdateDemarrage } from '@teetsh/app/src/containers/Demarrage/queries/useUpdateDemarrage';
import { useNavigate, useLocation } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import Button from '@teetsh/app/src/components/Buttons/Button';
import VictorySticker from '@teetsh/app/src/assets/victory-sticker.png';
import { Role } from 'types/user';
import { FinalizedIllustration } from 'containers/MesAnneesScolaires/School/Classrooms/assets/FinalizedIllustration';

function ensureDirectorAndTeacherRoles(currentRoles: Role[]): Role[] {
  const hasDirector = currentRoles.includes('director');
  const hasTeacher = currentRoles.includes('teacher');

  if (hasDirector && hasTeacher) {
    return currentRoles;
  }

  return ['director', 'teacher'];
}

export function Finalized() {
  const { data: demarrageData, isLoading } = useDemarrage();
  const finalize = useFinalizeDemarrage();
  const updateDemarrage = useUpdateDemarrage();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t } = useTranslation(['onboarding']);

  const urlSearchParams = new URLSearchParams(search);
  const isAddTeacherMode = urlSearchParams.get('mode') === 'add-teacher-role';

  if (isLoading || !demarrageData) {
    return null;
  }
  return (
    <StepWrapper
      title={t('onboarding:finalized.title')}
      currentStep="finalized"
      centerTitle
      presentationSlice
      nextDisabled
      hideFooter
    >
      <div tw="flex flex-col items-center justify-center">
        <div tw="relative mx-6">
          <div tw="absolute scale-[30%] top-0 right-2 translate-x-1/2 -translate-y-28">
            <img src={VictorySticker} />
          </div>
          <FinalizedIllustration />
        </div>
        <div tw="my-8 text-center text-neutral-moderate text-pretty space-y-1">
          <div>
            <Trans i18nKey="onboarding:finalized.description">
              Découvrez... <strong>30 jours Cahier Journal</strong> offerts par
              Teetsh !
            </Trans>
          </div>
          <div>{t('onboarding:finalized.description2')}</div>
        </div>
        <Button
          large
          intent="primary"
          onClick={async () => {
            let finalData = demarrageData;

            if (isAddTeacherMode) {
              const currentRoles = demarrageData?.roles || [];
              const updatedRoles = ensureDirectorAndTeacherRoles(currentRoles);
              await updateDemarrage({ roles: updatedRoles });
              finalData = { ...demarrageData, roles: updatedRoles };
            }

            const data = await finalize(finalData);
            const isDirector = finalData?.roles?.includes('director');
            const isTeacher = finalData?.roles?.includes('teacher');

            if (isAddTeacherMode) {
              return navigate('/dashboard');
            }

            if (isDirector && !isTeacher) {
              return navigate('/direction/school-subscription');
            }

            if (data?.edtId) {
              return navigate(
                `/annee-scolaire/${data?.schoolyearId}/ecole/${data?.schoolId}/emploi-du-temps/${data?.edtId}`,
              );
            }
            if (data?.programmationId) {
              return navigate(
                `/annee-scolaire/${data?.schoolyearId}/ecole/${data?.schoolId}/programmations/${data?.programmationId}?welcome=true`,
              );
            }
            if (data?.sequenceId) {
              return navigate(`/sequences/${data?.sequenceId}?welcome=true`);
            }
            navigate('/dashboard');
          }}
        >
          {t('onboarding:finalized.cta')}
        </Button>
      </div>
    </StepWrapper>
  );
}
